import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { NearbyHotels } from './NearbyHotels'
import * as styles from './SoldOutRecommend.module.scss'
import { WeeklyAvailabilityCalendar } from './WeeklyAvailabilityCalendar'

import { PATH } from '../../../constants'
import {
  useCreateNextPath,
  usePropertyProvider,
  usePublication,
  useSearchQueryParams,
} from '../../../hooks'
import { ButtonWrapper, Text } from '../../basics'

const translateNamespace = 'empty.soldOutRecommend'

export const SoldOutRecommend: React.FC = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const { publications } = usePropertyProvider()
  const publication = usePublication(i18n.language, publications)
  const propertyName = publication?.shortName ?? publication?.name ?? ''
  const {
    params: { property },
    onCreateNextPath,
  } = useCreateNextPath()
  const { params, onUpdateSearchParams } = useSearchQueryParams()

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        <Text size={18} weight="bold" align="center">
          {t(`${translateNamespace}.attention`, { propertyName })}
        </Text>
      </div>

      <WeeklyAvailabilityCalendar
        property={property}
        checkInDate={params.checkInDate}
        checkOutDate={params.checkOutDate}
        propertyName={propertyName}
        onSearch={(checkInDate, checkOutDate) =>
          // push（replace しない）。カレンダーで別日付を選んだ遷移を履歴に積み、
          // ブラウザ「戻る」で元の満室ページ（前の日付）に戻れるようにする。
          onUpdateSearchParams({ checkInDate, checkOutDate })
        }
      />

      <NearbyHotels property={property} params={params} />

      <div className={styles.button}>
        <ButtonWrapper
          htmlType="button"
          variant="primary"
          position="center"
          size="medium"
          onClick={() =>
            navigate(
              onCreateNextPath(PATH.search, {
                queryParams: { room: '', page: 1, showAll: false },
              })
            )
          }
        >
          {t(`${translateNamespace}.crossSearch`)}
        </ButtonWrapper>
      </div>
    </div>
  )
}
